(function () {
  var cache = {};

  function getCollectionMinPrice(handle, callback) {
    if (cache[handle] !== undefined) {
      callback(cache[handle]);
      return;
    }

    // The .json endpoint does not reliably honour sort_by, so we cannot trust the
    // first N products to contain the cheapest one. Page through the whole collection
    // (limit=250) and scan every variant for the true minimum price.
    var min = 0;

    function scan(products) {
      for (var i = 0; i < products.length; i++) {
        var variants = products[i].variants || [];
        for (var j = 0; j < variants.length; j++) {
          var price = parseFloat(variants[j].price);
          if (price > 0 && (min === 0 || price < min)) min = price;
        }
      }
    }

    function fetchPage(page) {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          scan(products);
          // A full page back means more may exist; keep paging (cap at 20 pages).
          if (products.length === 250 && page < 20) {
            fetchPage(page + 1);
          } else {
            cache[handle] = min;
            callback(min);
          }
        })
        .catch(function () {
          cache[handle] = min;
          callback(min);
        });
    }

    fetchPage(1);
  }

  function applyMinPrice(container) {
    var handle = container.dataset.collectionHandle;
    if (!handle) return;

    var currentMin = parseFloat(container.dataset.min) || 0;
    if (currentMin > 0) return; // already set correctly via Liquid

    getCollectionMinPrice(handle, function (minPrice) {
      if (minPrice <= 0) return;

      var attempt = 0;
      var maxAttempts = 20;

      function tryUpdate() {
        var sliderEl = container.querySelector('.price-range__slider');
        if (!sliderEl || !sliderEl.noUiSlider) {
          attempt++;
          if (attempt < maxAttempts) setTimeout(tryUpdate, 100);
          return;
        }

        var slider = sliderEl.noUiSlider;
        var maxVal = parseFloat(container.dataset.max) || 100;

        // Single price point — no useful range to filter, hide the whole filter
        if (minPrice >= maxVal) {
          var sidebarGroup = container.closest('[class*="collection-sidebar__group--"]');
          if (sidebarGroup) sidebarGroup.style.display = 'none';

          var panel = container.closest('.ck-filter-pill__panel');
          if (panel) {
            panel.hidden = true;
            var pill = document.querySelector('[aria-controls="' + panel.id + '"]');
            if (pill) {
              var pillWrapper = pill.closest('.ck-filter-pill-wrapper');
              if (pillWrapper) pillWrapper.style.display = 'none';
            }
          }
          return;
        }

        // Update the data attribute so theme.js knows the real min
        container.dataset.min = minPrice;

        // Update the display min if not filtered
        var minValueSet = parseFloat(container.dataset.minValue) || 0;
        var displayMin = container.querySelector('.price-range__display-min');
        var inputMin = container.querySelector('.price-range__input-min');

        slider.updateOptions({ range: { min: minPrice, max: maxVal } });

        if (minValueSet <= 0 || minValueSet < minPrice) {
          slider.set([minPrice, null]);
          if (displayMin) displayMin.textContent = slider.get()[0];
          if (inputMin) inputMin.value = minPrice;
          container.dataset.minValue = minPrice;
        }
      }

      tryUpdate();
    });
  }

  function initAll() {
    document.querySelectorAll('.price-range[data-collection-handle]').forEach(applyMinPrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-apply after AJAX filter re-renders
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('price-range') && node.dataset.collectionHandle) {
          applyMinPrice(node);
        } else {
          var inner = node.querySelectorAll && node.querySelectorAll('.price-range[data-collection-handle]');
          if (inner && inner.length) inner.forEach(applyMinPrice);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
